import React, {memo} from 'react';
import {Theme} from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import DescriptionIcon from '@mui/icons-material/DescriptionOutlined';
import classnames from 'classnames';
import Button from 'components/Button';

const useStyles = makeStyles((theme: Theme) => ({
   root: {
      textTransform: 'none',
      wordBreak: 'break-all',
   },
   selected: {
      backgroundColor: theme.palette.grey[300],
      '&:hover': {
         backgroundColor: theme.palette.grey[300],
      },
   },
}));

type FileFolderProps = {
   name: string;
   selected: boolean;
   onClick: () => void;
};

const FileItem = memo(({onClick, name, selected}: FileFolderProps) => {
   const classes = useStyles();
   // const name = truncate(_name, {length: 20});

   return (
      <Button
         variant={'text'}
         disableElevation
         disableRipple
         title={name}
         className={classnames(classes.root, {[classes.selected]: selected})}
         onClick={onClick}
         startIcon={<DescriptionIcon />}
      >
         {name}
      </Button>
   );
});

export default FileItem;
